import React from "react";
import { Box } from "@mui/material";
import {
    InitiativeAnnualIcon,
    InitiativePaybackIcon,
    InitiativeRoiIcon,
    InitiativeLeafIcon,
} from "assets";
import { useInitiativesOverview } from "hooks/api";
import { formatCurrency, formatLocaleNumber } from "utils";
import { MetricCard } from "components";

export const KpiSummaryCards = () => {
    const { data, isLoading, isError } = useInitiativesOverview();

    const cards = [
        {
            badge: "Annual",
            badgeIcon: <InitiativeAnnualIcon width={14} height={12} />,
            value: data ? formatCurrency(data.totalAnnualSavings) : "—",
            subtitle: "Total Annual Savings",
        },
        {
            badge: "Emissions",
            badgeIcon: <InitiativeLeafIcon width={12} height={12} />,
            value: data ? `${formatLocaleNumber(data.emissionsReduced)} tCO2e` : "—",
            subtitle: "Emissions Reduced",
        },
        {
            badge: "ROI (Discounted)",
            badgeIcon: <InitiativeRoiIcon width={9} height={12} />,
            value: data ? `${formatLocaleNumber(data.avgRoi)}%` : "—",
            subtitle: "Average ROI",
        },
        {
            badge: "Payback",
            badgeIcon: <InitiativePaybackIcon width={12} height={12} />,
            value: data ? `${formatLocaleNumber(data.avgPayback)} yrs` : "—",
            subtitle: "Average Payback",
        },
    ];

    return (
        <Box
            sx={{
                display: "grid",
                gap: 2,
                gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
            }}
        >
            {cards.map((card) => (
                <MetricCard
                    key={card.badge}
                    badge={card.badge}
                    badgeIcon={card.badgeIcon}
                    value={card.value}
                    subtitle={card.subtitle}
                    isLoading={isLoading}
                    isError={isError}
                />
            ))}
        </Box>
    );
};
